import { useQuery, UseQueryResult } from 'react-query';
import categoryService from '../../services/categoryService';
import { ICategoryDTO } from '../../shared/interfaces/category-interfaces';

enum ServiceKeys {
  listCategories = 'listCategories',
}

const fetchCategories = async () => {
  const response = await categoryService.list();

  return response.data;
};

export const useGetCategories = (): UseQueryResult<ICategoryDTO[]> => {
  return useQuery(ServiceKeys.listCategories, fetchCategories, {
    staleTime: 1000 * 60 * 3,
    keepPreviousData: false,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
